import { render, staticRenderFns } from "./ChatSwitch.vue?vue&type=template&id=1d6dd59d&scoped=true&"
import script from "./ChatSwitch.vue?vue&type=script&lang=js&"
export * from "./ChatSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ChatSwitch.vue?vue&type=style&index=0&id=1d6dd59d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6dd59d",
  null
  
)

export default component.exports